/** Undo / redo availability, mirrored from the engine's history stacks. */

import { historyState } from "./history.state.ts";

export function setHistoryAvailability(canUndo: boolean, canRedo: boolean): void {
  historyState.set({ canUndo, canRedo });
}
